module.exports = __webpack_public_path__ + "img/slika23.5b31bcef.jpg";